module.exports = __webpack_public_path__ + "img/image51.0a6cdcd3.png";